// custom-list.module.ts
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatTableModule } from '@angular/material/table';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSortModule } from '@angular/material/sort';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { ReactiveFormsModule } from '@angular/forms';
import { NbButtonModule, NbCheckboxModule, NbIconModule, NbCardModule, NbSpinnerModule, NbMenuModule, NbContextMenuModule } from '@nebular/theme';
import { MatSelectModule } from "@angular/material/select";
import { TranslateModule } from '@ngx-translate/core';

import { CustomListComponent } from './custom-list/custom-list.component';
import { CustomListLayoutComponent } from './custom-list-layout/custom-list-layout.component';
import { CustomListFiltersComponent } from './custom-list-filter/custom-list-filters.component';
import { ColumnSettingsComponent } from './column-settings/column-settings.component';
import { ActionButtonComponent } from '../action-button/action-button.component';
import { DropdownActionButtonComponent } from '../dropdown-action-button/dropdown-action-button.component';
import { CommonPipesModule } from "../../../common-modules/common-pipes/common-pipes.module";
import { FilterSettingsComponent } from './filter-settings/filter-settings.component';

@NgModule({
  declarations: [
    CustomListComponent,
    CustomListLayoutComponent,
    CustomListFiltersComponent,
    ColumnSettingsComponent,
    ActionButtonComponent,
    DropdownActionButtonComponent,
    FilterSettingsComponent
  ],
  imports: [
    CommonModule,
    MatTableModule,
    MatPaginatorModule,
    MatSortModule,
    MatFormFieldModule,
    MatInputModule,
    ReactiveFormsModule,
    MatSelectModule,
    NbButtonModule,
    NbCheckboxModule,
    NbIconModule,
    NbCardModule,
    NbSpinnerModule,
    NbMenuModule,
    NbContextMenuModule,
    TranslateModule,
    CommonPipesModule
],
  exports: [
    CustomListComponent,
    CustomListLayoutComponent,
    CustomListFiltersComponent,
    ColumnSettingsComponent,
    ActionButtonComponent,
    DropdownActionButtonComponent,
    FilterSettingsComponent
  ]
})
export class CustomListModule { }
